import React, { FunctionComponent } from 'react'
import { connect } from 'react-redux'
import { getFieldVisibility } from '../../../../reducers/bookingCalendar/selectors/reservationForm'
import { ReservationFormFieldVisibility } from '../withReduxForm'

const VisibilityControlled: FunctionComponent<
  IVisibilityControlledProps & IVisibilityControlledStore
> = ({ isVisible, children }) => {
  return <>{isVisible && children}</>
}

export interface IVisibilityControlledProps {
  children?: any
  field:
    | keyof ReservationFormFieldVisibility
    | (keyof ReservationFormFieldVisibility)[]
}

export interface IVisibilityControlledStore {
  isVisible: boolean
}

const mapStateToProps = (
  state,
  ownProps: IVisibilityControlledProps,
): IVisibilityControlledStore => {
  return {
    isVisible: Array.isArray(ownProps.field)
      ? ownProps.field.some(field => getFieldVisibility(state, field))
      : getFieldVisibility(state, ownProps.field),
  }
}

export default connect(mapStateToProps)(VisibilityControlled)
